module.exports = __webpack_public_path__ + "static/img/product_img_5.f268c09.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/nav/img/product_img_5.png
// module id = sAG/
// module chunks = 22